import { render, staticRenderFns } from "./CustomerEditView.vue?vue&type=template&id=4f6de133&scoped=true&"
import script from "./CustomerEditView.vue?vue&type=script&lang=js&"
export * from "./CustomerEditView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEditView.vue?vue&type=style&index=0&id=4f6de133&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6de133",
  null
  
)

export default component.exports